import React, {Component} from 'react';
import {observer} from 'mobx-react';
import ServerAPI from '../ServerAPI';

import {green500,blue500,red500,gray500} from 'material-ui/styles/colors';


import Avatar from 'material-ui/Avatar';

import Job from 'material-ui/svg-icons/action/restore';
import Check from 'material-ui/svg-icons/navigation/check';
import ErrorOutline from 'material-ui/svg-icons/alert/error-outline';
import AlarmOn from 'material-ui/svg-icons/action/alarm-on';
import RadioButtonChecked from 'material-ui/svg-icons/toggle/radio-button-checked';

// Run API test on every reload
//ServerAPI.testAPI(ServerAPI);
export default
@observer class JobAvatar extends Component {
  render() {
    var job = this.props.job;
    return JobAvatar.pickRightJobAvatar(job);
  }

  static pickRightJobAvatar(job) {
    var job_color = {
        'SUCCESS' : green500,
        'ABORT'   : blue500,
        'ALARM'   : red500,
        'ERROR'   : red500
      }[job.status] || gray500;
    var job_icon = {
        'SUCCESS' : <Check />,
        'ABORT'   : <RadioButtonChecked />,
        'ALARM'   : <AlarmOn />,
        'ERROR'   : <ErrorOutline />
    }[job.status] || <ErrorOutline />;
    if(job.running) return <Avatar icon={<Job />} backgroundColor={green500} />
    return <Avatar icon={job_icon} backgroundColor={job_color} />
  }

};



/** WEBPACK FOOTER **
 ** ./src/components/JobAvatar.jsx
 **/